module.exports = __webpack_public_path__ + "f23532b56e3114ea2bb2ae4db1e54799.png";